import axios from "axios";
import { Auth } from "../utils/auth";
import config from "../config";

export type CreateTickedDto = {
  phone: string;
  mobile: string;
  secondaryEmail: string;
  subject: string;
  description: string;
  priority: string;
};

export const createTicket = async (requestData: CreateTickedDto) => {
  const token = await Auth.getToken([]);
  await axios({
    method: 'post',
    url: `${config.zohoBackendUrl}/tickets`,
    headers: {
      Authorization: `Bearer ${token.token}`
    },
    data: requestData
  });
}
  